import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import routes from "./routes";
import Cookies from "js-cookie";
import VueGtag from "vue-gtag";
import VueGtm from 'vue-gtm';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  scrollBehavior: (to, _from, savedPosition) =>
    new Promise(resolve => {
      const position = savedPosition || {};

      // savedPosition is only available for popstate navigations.
      if (!savedPosition) {
        if (to.hash) {
          position.selector = to.hash;
        }

        // Check if any matched route config has meta that requires scrolling to top
        if (to.matched.some(m => m.meta.scrollToTop)) {
          position.x = 0;
          position.y = 0;
        }
      }

      // Wait for the out transition to complete (if necessary)
      router.app.$root.$once("triggerScroll", () => {
        router.app.$nextTick(() => resolve(position));
      });

      resolve(position);
    }),
  routes: routes.map(route => {
    return {
      ...route,
      path: route.path === "/" ? "/" : `/:lang?${route.path}`
    };
  })
});

router.beforeEach(async (to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public);
  const onlyWhenLoggedOut = to.matched.some(
    record => record.meta.onlyWhenLoggedOut
  );
  const loggedIn = store.getters["auth/token"];
  const hasLang = !!to.params.lang;

  let lang;

  // Make lang as query when is home
  if (["/", "/es", "/en"].includes(to.path)) {
    if (
      (to.path === "/" && !to.query.lang) ||
      !["es", "en"].includes(to.query.lang)
    ) {
      if (["/", "/en"].includes(to.path)) {
        lang = 'en';
      } else {
        lang = 'es';
      }

      await store.dispatch("locale/setLocale", lang);
    } else if (to.path !== "/") {
      return next({
        path: "/",
        query: {
          lang: to.path.replace("/", "")
        }
      });
    }
  } else if (to.name !== "404") {
    // Get locale
    lang = from.params.lang || to.params.lang || Cookies.get("locale");
    if (!["es", "en"].includes(lang)) {
      to.params.lang = undefined;
      lang = "en";
    }

    // Keep lang across routes
    if (!to.params.lang) {
      let redirectTo = to.fullPath;

      // Remove invalid lang
      if (hasLang) {
        redirectTo = redirectTo.replace(/(\/\w+\/)/g, "/");
      }

      return next({
        path: `/${lang}${redirectTo}`,
        query: to.query
      });
    }
  }

  if (!isPublic && !onlyWhenLoggedOut && !loggedIn) {
    return next({
      path: `/${lang}/login`,
      query: { redirect: to.fullPath } // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next({
      path: `/${lang}/profile`
    });
  }

  // Set locale
  if (from.params.lang !== lang) {
    await store.dispatch("locale/setLocale", lang);
  }

  // Wait for fetch user profile
  if (loggedIn) {
    await store.dispatch("auth/fetchUser");
  }

  return next();
});

// Add google analitycs
Vue.use(VueGtag, {
  config: { id: "UA-129519907-1" },
  appName: 'JWperfectmatch',
  pageTrackerScreenviewEnabled: true
}, router);

/*Vue.use(VueGtm, {
  id: 'AW-658694058',
  enabled: true,
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});*/

export default router;
